module.exports = __webpack_public_path__ + "img/article10-4.65d42c37.jpg";